import { render, staticRenderFns } from "./AppChips.vue?vue&type=template&id=3339ad6a"
import script from "./AppChips.vue?vue&type=script&lang=js"
export * from "./AppChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports